// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__3sLy9","form":"styles_form__3oxkS"};